import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useHandlingConversation = (): IGlobalStore['handling_conversation'] => {
  return useSelector((store: IReducerStore) => store.global.handling_conversation);
};
